export const converterEmbalagemValor = (valor, embalagem_master_ativa, tipo_fator, multiplo_compra) => {
  if (!embalagem_master_ativa) {
    return Number(valor || 0);
  }

  if (tipo_fator === 'D') {
    return Number((valor / multiplo_compra) || 0);
  }

  return Number((valor * multiplo_compra) || 0);
}

export const converterValorParaEmbalagemMinima = (valor, tipo_fator, multiplo_compra) => {
  if (tipo_fator === 'D') {
    return Number((valor * multiplo_compra) || 0);
  }

  return Number((valor / multiplo_compra) || 0);
}

const convercaoEmbalagemItem = (item, embalagem_master_ativa) => {
  if (embalagem_master_ativa && item.tipo_fator_conversao === 'D') {
    item.estoque = item.estoque / item.multiplo_compra;
    item.qtd_no_carrinho = item.qtd_no_carrinho / item.multiplo_compra;
    item.sugestao = item.sugestao / item.multiplo_compra;
    item.estoque_transito = item.estoque_transito / item.multiplo_compra;
    item.estoque_minimo = item.estoque_minimo / item.multiplo_compra;
    item.sugestao_transferencia = item.sugestao_transferencia / item.multiplo_compra;
    item.consumo_medio_mensal_auxiliar = item.consumo_medio_mensal_auxiliar / item.multiplo_compra;
    item.lote_minimo = item.lote_minimo / item.multiplo_compra;
    item.estoque_futuro_tempo_ressuprimento = item.estoque_futuro_tempo_ressuprimento / item.multiplo_compra;
    return item;
  }

  item.estoque = item.estoque * item.multiplo_compra;
  item.qtd_no_carrinho = item.qtd_no_carrinho * item.multiplo_compra;
  item.sugestao = item.sugestao * item.multiplo_compra;
  item.estoque_transito = item.estoque_transito * item.multiplo_compra;
  item.estoque_minimo = item.estoque_minimo * item.multiplo_compra;
  item.sugestao_transferencia = item.sugestao_transferencia * item.multiplo_compra;
  item.consumo_medio_mensal_auxiliar = item.consumo_medio_mensal_auxiliar * item.multiplo_compra;
  item.lote_minimo = item.lote_minimo * item.multiplo_compra;
  item.estoque_futuro_tempo_ressuprimento = item.estoque_futuro_tempo_ressuprimento * item.multiplo_compra;

  return item;
};

export const converterEmbalagemItens = (itens, embalagem_master_ativa) => {
  return itens.map(item => convercaoEmbalagemItem(item, embalagem_master_ativa));
}
